module.exports = __webpack_public_path__ + "src/assets/images/user.d4838db1ff905957c20b7be6c08d07fa.svg";